import { Navigate, useParams } from 'react-router-dom';
import { ROUTES } from '@/app/router/routes';
import { findModule } from '@/app/router/modules';
import { ModuleDashboard } from '@/components/os/ModuleDashboard';
import { useAuth } from '@/features/auth/useAuth';
import { NotFoundPage } from '@/features/errors/ErrorPages';
import { useModuleBadges } from './useModuleBadges';

/**
 * /dashboard/:moduleKey — any module, rendered from the registry.
 *
 * An unknown key is a 404; a module the user can open nothing in goes to the
 * forbidden page, exactly as a guarded route would.
 */
export function ModuleDashboardPage() {
  const { moduleKey } = useParams();
  const { canAny } = useAuth();
  const badges = useModuleBadges();
  const module = findModule(moduleKey);

  if (module === undefined) {
    return <NotFoundPage />;
  }

  const subModules = module.subModules.filter((sub) => canAny(sub.permissions));
  if (subModules.length === 0) {
    return <Navigate to={ROUTES.forbidden} replace />;
  }

  return (
    <ModuleDashboard
      moduleKey={module.key}
      title={module.title}
      description={module.description}
      icon={module.icon}
      accent={module.accent}
      subModules={subModules}
      badges={badges.subModules[module.key]}
    />
  );
}
